import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

// Routes
import { canNavigate } from "@/libs/acl/routeProtection";
import { isUserLoggedIn, getUserRoles, getHomeRouteForLoggedInUser } from "@admin/../auth/utils.js";

import admin from "@/app/admin/routes";

Vue.use(VueRouter);

export const All = "all";
export const Admin = "Admin";
export const DataEntry = "DataEntry";
export const Teacher = "Teacher";
export const Accountant = "Accountant";
export const SuperAdmin = "SuperAdmin";
const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
        store.dispatch("app/setLoading", false);
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: "/",
            redirect: "/admin"
        },
        {
            path: "/admin",
            components: {
                default: () => import("@/app/admin/Admin.vue"),
                "bread-actions": () =>
                    import(
                        "@/app/admin/layouts/components/AdminBreadActions.vue"
                    )
            },
            children: admin
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@/app/admin/auth/Login.vue"),
            meta: () => ({
                pageTitle: "login",
                roles: [All],
                redirectIfLoggedIn: true
            })
        },
        {
            path: "/access-denied",
            name: "access-denied",
            component: () => import("@global/pages/NotAuthorized.vue"),
            meta: () => ({
                pageTitle: "access-denied",
                roles: [All]
            })
        },
        {
            path: "/server-error",
            name: "server error",
            component: () => import("@global/pages/server-error.vue"),
            meta: () => ({
                pageTitle: "conection-error",
                roles: [All]
            })
        },
        {
            path: "/error-404",
            name: "error 404",
            meta: () => ({
                pageTitle: "not-found",
                roles: [All]
            }),
            component: () => import("@global/pages/error-404.vue")
        },

        {
            path: "*",
            redirect: "/error-404"
        }
    ]
});

router.beforeEach((to, from, next) => {
    const isLoggedIn = isUserLoggedIn();

    // Set document title
    document.title = !to.meta(to).breadcrumb
        ? !to.meta(to).pageTitle
            ? to.meta(to).title
            : to.meta(to).pageTitle
        : to.meta(to).breadcrumb[0].text;

    // If user is trying to access login page and is already logged in
    if (to.name === 'login' && isLoggedIn) {
        const userRole = getUserRoles();
        const homeRoute = getHomeRouteForLoggedInUser(userRole);
        return next(homeRoute);
    }

    // Check if user can navigate to the route
    if (!canNavigate(to)) {
        // Redirect to login if not logged in
        if (!isLoggedIn) {
            // Avoid infinite redirect loops
            if (to.name !== 'login') {
                return next({ name: 'login' });
            }
        } else {
            // If logged in but not authorized
            return next("/access-denied");
        }
    }

    return next();
});

export default router;
